import { GET_FULL_STAT } from './types';

let initialState = {
  // full_stat: {
  //   daily_view_stat: {
  //     data: [30, 70, 55, 110, 90],
  //     labels: ["Aug 07'18", "Aug 14'18", "Aug 21'18", "Aug 28'18", "Sep 04'18"],
  //   },
  //   monthly_view_stat: {
  //     data: [0, 170, 155, 400, 250],
  //     labels: ["May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18"],
  //   },
  //   browsers: {
  //     data: [50, 10, 5, 20, 15, 10],
  //     labels: ['chrome', 'edge', 'firefox', 'safari', 'opera', 'other'],
  //   },
  //   operation_systems: {
  //     data: [45, 10, 7, 13, 17, 3],
  //     labels: ['ios', 'macintosh', 'android', 'linux', 'windows', 'other'],
  //   },
  //   cities_top: [
  //     'Pride, Louisiana, USA',
  //     'Brisbane, Queensland, Australia',
  //     'Sydney, New South Wales, Australia',
  //   ],
  //   countries_top: ['Australia', 'USA', 'New Zealand', 'Ukraine'],
  //   referrers_top: ['Instagram.com', 'www.instalinks.com', 'www.google.com'],
  // },
  full_stat: {
    daily_view_stat: {
      data: [0, 0, 0, 0, 0],
      labels: ['', '', '', '', ''],
    },
    monthly_view_stat: {
      data: [0, 0, 0, 0, 0],
      labels: ['', '', '', '', ''],
    },
    browsers: {
      data: [0, 0, 0, 0, 0],
      labels: ['', '', '', '', ''],
    },
    operation_systems: {
      data: [0, 0, 0, 0, 0],
      labels: ['', '', '', '', ''],
    },
    cities_top: ['', '', '', '', ''],
    countries_top: ['', '', '', '', ''],
    referrers_top: ['', '', '', '', ''],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FULL_STAT:
      return {
        ...state,
        full_stat: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/analitics/reducer.js